import { ArrowLeft } from "lucide-react";

/**
 * Step Header component with back button and title
 */
export const StepHeader = ({ 
  title, 
  subtitle = null,
  onBack = null,
  showBack = true 
}) => {
  return (
    <div className="mb-6">
      {showBack && onBack && (
        <button
          onClick={onBack}
          className="flex items-center gap-2 text-[#1F2933]/60 hover:text-[#1F2933] mb-4 transition-colors"
          data-testid="wizard-back-button"
        >
          <ArrowLeft className="w-4 h-4" />
          <span className="text-sm">Back</span>
        </button>
      )}
      <h2 className="text-2xl font-bold text-[#1F2933] mb-2">{title}</h2>
      {subtitle && (
        <p className="text-[#1F2933]/60">{subtitle}</p>
      )}
    </div>
  );
};

export default StepHeader;
